<!-- MitreDetailDialog.vue -->
<template>
  <el-drawer
    v-model="drawerVisible"
    :size="1200"
    custom-class="attck-drawer-class"
    @close="handleClose"
    :with-header="true"
    direction="rtl"
    append-to-body
  >
    <template #header>
      <div class="title-wrap">
        <span class="title">{{ $t('report.analyse.mitre_att.dialog.title1') }}</span>
      </div>
    </template>
    <div
      v-if="!showDetail"
      class="attckTable-wrap animate__animated animate__faster"
      v-loading="loading"
      element-loading-background="transparent"
    >
    </div>
    <div v-else class="attckDetail-wrap">
      <div class="detail-mitre">
        <div class="row">
          <div>ATT&CK ID</div>
          <div><span>{{ attack.attackid }}</span></div>
        </div>
        <div class="row">
          <div>{{ $t('report.analyse.mitre_att.dialog.name') }}</div>
          <div>{{ attack.name }}</div>
        </div>
        <div class="row">
          <div>{{ $t('report.analyse.mitre_att.dialog.tactics') }}</div>
          <div>{{ attack.tactics.map(v => v.name).join('、') }}</div>
        </div>
        <div class="row">
          <div>{{ $t('report.analyse.mitre_att.dialog.required_permissions') }}</div>
          <div>
            {{
              attack.x_mitre_permissions_required
                ? attack.x_mitre_permissions_required.join(',')
                : '-'
            }}
          </div>
        </div>
        <div class="row">
          <div>{{ $t('report.analyse.mitre_att.dialog.source') }}</div>
          <div>
            <a :href="attack.url" rel="noreferrer" target="_blank">{{ attack.url }}</a>
          </div>
        </div>
        <div class="row">
          <div>{{ $t('report.analyse.mitre_att.dialog.explain') }}</div>
          <div v-html="renderedDescription" class="description-wrap"></div>
        </div>
      </div>
      <div class="detail-right">
        <div class="row" style="height: 100%;">
          <div class="title">{{ $t('report.analyse.mitre_att.dialog.target') }}</div>
          <div class="cardsWrap">
            <!-- <sand-no-data v-if="!hasSigs"/> -->
            <no-data v-if="!hasSigs" style="margin-top:180px;" width="80" height="80"></no-data>
            <div
              class="card"
              v-for="group in groupedSigs"
              :key="group.id"
            >
              <div class="card-title">{{ `${group.id} ${group.name}` }}</div>
              <div class="content">
                <div
                  v-for="(descItem, index) in group.descriptions"
                  :key="index"
                  :style="{
                    color:
                      descItem.severity === 1 ? '#00AB7A' : descItem.severity === 2 ? '#F58A02' : '#F0131E'
                  }"
                >
                  {{ descItem.desc }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import MarkdownIt from 'markdown-it'
// import sandNoData from '@/components/report/sandNoData'
export default {
  name: 'MitreDetailDrawer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    attack: {
      type: Object,
      required: true
    },
    sigs: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    showDetail: {
      type: Boolean,
      default: false
    }
  },
  components: {
  },
  data() {
    return {
      md: new MarkdownIt()
    }
  },
  computed: {
    renderedDescription() {
      return this.md.render(this.attack.description || '')
    },
    drawerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    hasSigs() {
      return this.sigs[this.attack.attackid] && this.sigs[this.attack.attackid].length > 0
    },
    groupedSigs() {
      if (!this.attack.attackid || !this.sigs[this.attack.attackid]) {
        return []
      }
      const groupedMap = new Map()
      this.sigs[this.attack.attackid].forEach(item => {
        const key = item.id
        if (!groupedMap.has(key)) {
          groupedMap.set(key, {
            id: item.id,
            name: item.name,
            descriptions: []
          })
        }
        groupedMap.get(key).descriptions.push({
          desc: item.desc,
          severity: item.severity
        })
      })
      const groupedItems = Array.from(groupedMap.values())
      return groupedItems.sort((a, b) => {
        const aIsSub = a.id.includes('.')
        const bIsSub = b.id.includes('.')
        if (!aIsSub && bIsSub) return -1
        if (aIsSub && !bIsSub) return 1
        return a.id.localeCompare(b.id)
      })
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:showDetail', false)
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/common.scss';

[lang="en"] {
  .attck-drawer-class {
    .el-drawer__body {
      .attckDetail-wrap {
        .detail-mitre {
          .row {
            div:first-child {
              width: 166px;
            }
          }
        }
      }
    }
  }
}

.attck-drawer-class {
  overflow: hidden;
  // min-width: 1200px;
  .el-drawer__header {
    margin-bottom: 0;
    padding: 16px 24px;
    .title-wrap {
      display: flex;
      justify-content: space-between;
      .title {
        font-size: 16px;
        color: var(--color-text-1);
        font-weight: 500;
      }
    }
  }
  .el-drawer__body {
    padding: 0 24px 0 0;
    .attckTable-wrap {
      min-height: 50vh;
      display: flex;
      flex-direction: column;
    }
    .attckDetail-wrap {
      display: flex;
      height: 100%;
      span {
        cursor: pointer;
      }
      .detail-right {
        flex: 1;
        padding: 20px 0 0 20px;
        .title {
          font-weight: 700;
          font-size: 14px;
          color: var(--color-text-1);
        }
        .cardsWrap {
          padding: 16px 0;
          display: flex;
          flex-direction: column;
          gap: 16px;
          height: calc(100% - 56px);
          overflow-y: auto;
          .card {
            border: 1px solid var(--color-border-2);
            border-radius: 4px;
            .card-title {
              border-radius: 4px 4px 0px 0px;
              line-height: 36px;
              padding: 0 16px;
              background: var(--color-bg-3);
              border-bottom: 1px solid var(--color-border-2);
              color: var(--color-text-1);
            }
            .content {
              padding: 16px;
              display: flex;
              flex-direction: column;
              gap: 8px;
            }
          }
        }
      }
      .noborder {
        border: none !important;
      }
      .detail-mitre {
        padding: 20px 20px 16px 0;
        flex: 1;
        border-right: 1px solid var(--color-border-2);
        overflow-y: auto;
        .row {
          display: flex;
          margin-bottom: 16px;
          div:first-child {
            width: 106px;
            margin-right: 24px;
            font-weight: 700;
            font-size: 14px;
            color: var(--color-text-1);
            text-align: right;
          }
          div:last-child {
            flex: 1;
            font-size: 14px;
            color: var(--color-text-2);
            overflow-wrap: anywhere;
            a:link, a:visited {
              color: #537EF3;
            }
          }
          .description-wrap {
            line-height: 1.5;
            p {
              line-height: 1.5;
              margin: 0;
            }
            code {
              background-color: var(--color-bg-3);
              padding: 2px 4px;
              border-radius: 4px;
              font-family: monospace;
              font-size: 0.9em;
              border: 1px solid var(--color-border-2);
              line-height: 26px;
              word-break: break-all;
            }
            pre {
              background-color: var(--color-bg-3);
              padding: 12px;
              border-radius: 4px;
              overflow-x: auto;
              margin: 8px 0;
              border: 1px solid var(--color-border-2);
              code {
                background-color: transparent;
                padding: 0;
                border: none;
              }
            }
          }
          ul {
            padding-inline-start: 20px;
            margin: 0;
            li {
              list-style-type: disc;
              line-height: 1.5;
            }
          }
        }
      }
    }
  }
}
</style>
